import { CascadeVerticalItem } from './cascade-vertical-item';
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output
  } from '@angular/core';


// todo é¡¹ç®åç±»ç»ä»¶éè¦å¨è¯¥ç»ä»¶ä¸è¿è¡éæ°å¼å
@Component({
  selector: 'nec-cascade',
  templateUrl: './cascade.component.html',
  styleUrls: ['./cascade.component.scss']
})
export class NecCascadeComponent implements OnInit {
  @Input() cascadeButtonDefaultText: string;
  @Input() cascadeHorizontalItemWidth = 180;
  @Input() cascadeVerticalHeight = 320;
  @Input() maxColumnNum = 10;
  @Input() rootCascadeItems: CascadeVerticalItem[];
  @Output() cascadeVerticalChosenItem: EventEmitter<CascadeVerticalItem> = new EventEmitter();
  cascadeButtonClicked: boolean;
  chosenVerticalItem: CascadeVerticalItem;
  cascadeItem: CascadeVerticalItem[][];
  showCascadeItems: boolean[];

  constructor(private elementRef: ElementRef) {
    document.addEventListener('click', this.offClickHandler.bind(this));
  }

  ngOnInit() {
    this.cascadeButtonClicked = false;
    // åå§åéä¸­é¡¹
    this.chosenVerticalItem = new CascadeVerticalItem(null, null, this.cascadeButtonDefaultText);
    if (!this.maxColumnNum) {
      throw new Error('data bind error');
    }
    this.cascadeItem = new Array<Array<CascadeVerticalItem>>(this.maxColumnNum);
    this.showCascadeItems = new Array<boolean>(this.maxColumnNum);
    this.cascadeItem[0] = this.rootCascadeItems;
  }

  cascadeButtonClick() {
    this.cascadeButtonClicked = !this.cascadeButtonClicked;
    if (!this.showCascadeItems[0]) {
      this.showCascadeItems[0] = true;
    }
  }

  /**
   * è·å¾æ¨ªååç§»é¿åº¦
   */
  getHorizontalPosition(num: number): string {
    return (num * this.cascadeHorizontalItemWidth + num * 4) + 'px';
  }

  /**
   * çºµåæé«é«åº¦
   */
  getCascadeVerticalItemHeight(): string {
    return this.cascadeVerticalHeight + 12 + 'px';
  }

  /**
   * è·å¾æ¨ªååå®½åº¦
   */
  getCascadeHorizontalItemWidth() {
    return this.cascadeHorizontalItemWidth + 'px';
  }

  cascadeVerticalItemClick(currentHorizontalItemCount: number, cascadeVerticalItem: CascadeVerticalItem) {
    let nextHorizontalItemCount = currentHorizontalItemCount + 1;
    if (currentHorizontalItemCount < this.maxColumnNum - 1 && cascadeVerticalItem.hasChild()) {
      /**
       * éæ°å è½½å½åå³è¾¹è¾¹å
       * @type {Array<CascadeVerticalItem>}
       */
      this.cascadeItem[nextHorizontalItemCount] = cascadeVerticalItem.children;
    }
    /**
     * æ¸ç©ºææåéä¸­ç¶æ å¹¶å°å½åé¡µå³è¾¹éé¡¹éè
     */
    for (let index = currentHorizontalItemCount; index < this.maxColumnNum; index++) {
      if (this.cascadeItem[index]) {
        this.cascadeItem[index].forEach(item => item.chosen = false);
      }
      this.showCascadeItems[index + 1] = false;
    }
    /**
     * æ¯å¦æ¾ç¤ºå½ååçå³è¾¹å
     * @type {boolean}
     */
    this.showCascadeItems[nextHorizontalItemCount] = cascadeVerticalItem.hasChild();
    cascadeVerticalItem.chosen = true;
    this.chosenVerticalItem = cascadeVerticalItem;
    /**
     * æåä¸åèªå¨éèä¸æèå
     */
    if (currentHorizontalItemCount === this.maxColumnNum - 1 || !cascadeVerticalItem.hasChild()) {
      this.cascadeButtonClicked = false;
    }
    this.cascadeVerticalChosenItem.emit(cascadeVerticalItem);
  }

  /**
   * å¤çé¼ æ ç¹å»ç»ä»¶å¤åç´ äºä»¶
   * event äºä»¶
   */
  offClickHandler(event: any) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      if (this.cascadeButtonClicked) {
        this.cascadeButtonClicked = false;
      }
    }
  }

}


